<template>
  <div>
    <h3 class="spl-report-style">
      Name *
    </h3>
    <form-input
      v-model="name"
      required="true"
      data-cy="report-edit-name" />
    <h3 class="spl-report-style">
      Description
    </h3>
    <form-textarea
      v-model="description"
      :required="false"
      data-cy="report-edit-description" />
    <h3 class="spl-report-style">
      Private
    </h3>
    <form-checkbox
      :checked="isPrivate"
      data-cy="report-edit-private"
      @checkboxChanged="handlePrivateChanged">
      Report is private
    </form-checkbox>
    <h3 class="spl-report-style">
      Based on Problem Report
    </h3>
    <form-checkbox
      :checked="baseOnProblemReport"
      data-cy="report-edit-based-on-problem-report"
      @checkboxChanged="handleBaseOnProblemReport">
      Report is Based on Problem Reports
    </form-checkbox>
  </div>
</template>

<script lang="ts">
import { mapState, mapMutations } from 'vuex'
import { set, cloneDeep } from 'lodash'
export default {
  data () {
    return {
      name: '',
      description: '',
      isPrivate: false,
      baseOnProblemReport: false
    }
  },
  computed: {
    ...mapState('report', ['currentEditReport'])
  },
  watch: {
    name () {
      this.setCurrentEditReport(set(cloneDeep(this.currentEditReport), 'Report_Name', this.name))
    },
    description () {
      this.setCurrentEditReport(set(cloneDeep(this.currentEditReport), 'Report_Description', this.description))
    }
  },
  mounted () {
    this.name = this.currentEditReport.Report_Name
    this.isPrivate = this.currentEditReport.Private
    this.description = this.currentEditReport.Report_Description
    this.baseOnProblemReport = this.currentEditReport.Base_On_Problem_Report
  },
  methods: {
    ...mapMutations('report', ['setCurrentEditReport']),
    handlePrivateChanged (value) {
      this.isPrivate = value
      this.setCurrentEditReport(set(cloneDeep(this.currentEditReport), 'Private', this.isPrivate))
    },
    handleBaseOnProblemReport (value) {
      this.baseOnProblemReport = value
      this.setCurrentEditReport(set(cloneDeep(this.currentEditReport), 'Base_On_Problem_Report', this.baseOnProblemReport))
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-report-style {
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
